/* ==========================================================================
   VM · Euroteken altijd VÓÓR het bedrag (verzoek Joas 20-aug-2026)

   Liquid rendert prijzen met de winkelinstelling money_format
   (€{{amount_with_comma_separator}}), dus server-side staat het teken al
   vooraan. Twee scripts herschrijven prijzen daarna in de browser met
   Intl.NumberFormat(..., {style:"currency"}), en die zet het in het Spaans
   juist ACHTER het bedrag ("49,95 €"):

     assets/cart-drawer.js   → CartDrawerController.formatMoney()
     assets/product-page.js  → ProductSectionController.formatMoney()

   Dit bestand doet twee dingen:

   1) het vervangt die twee methodes, zodat alles wat DAARNA wordt getekend
      (variantwissel, cart bijwerken) de goede volgorde krijgt;

   2) het herstelt de prijzen die AL op de pagina staan. Dat is nodig omdat
      product-page.js geen DOMContentLoaded gebruikt maar zichzelf meteen
      uitvoert: de PDP-prijs is dus al één keer verkeerd getekend voordat dit
      script aan de beurt is. Zonder stap 2 bleef "24,95 €" staan tot de
      klant een maat aanklikte.

   Het getal wordt opgebouwd zoals Liquid's amount_with_comma_separator
   (punt voor duizendtallen, komma voor centen), niet via Intl — anders kan
   een andere browser-locale alsnog een afwijkende opmaak geven.

   Laden: als LAATSTE defer-script in layout/theme.liquid, ná cart-drawer.js.
   ========================================================================== */

(function () {
  var SYMBOLS = { EUR: '€', USD: '$', GBP: '£' };

  /* "49,95 €" → "€49,95" · "1.234,50 €" → "€1.234,50" · "- 25,00 €" → "-€25,00"
     Let op: het minteken zit in een eigen optionele groep. Zou het los als
     (-?)\s* ervoor staan, dan slikt de \s* de spatie vóór het bedrag op en
     wordt "Ahorra 25,00 €" → "Ahorra€25,00" (zonder spatie). */
  var MONEY_AFTER = /(?:(-)\s*)?(\d[\d.]*,\d{2})\s*€/g;

  function activeCurrency() {
    return (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';
  }

  /* 49.95 → "49,95"  ·  1234.5 → "1.234,50" (altijd het absolute bedrag) */
  function withCommaSeparator(amount) {
    var parts = Math.abs(amount).toFixed(2).split('.');
    var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return whole + ',' + parts[1];
  }

  /* centen → "€49,95" */
  function formatMoney(cents, currency) {
    var code = currency || activeCurrency();
    var amount = (Number(cents) || 0) / 100;
    var symbol = SYMBOLS[code];

    if (!symbol) {
      return new Intl.NumberFormat('es-ES', { style: 'currency', currency: code }).format(amount);
    }

    return (amount < 0 ? '-' : '') + symbol + withCommaSeparator(amount);
  }

  window.vmFormatMoney = formatMoney;

  /* ---- 1. de twee formatters vervangen ---------------------------------- */

  function patch() {
    try {
      if (CartDrawerController && CartDrawerController.prototype) {
        CartDrawerController.prototype.formatMoney = function (cents) {
          return formatMoney(cents, this.currency);
        };
      }
    } catch (e) {}

    try {
      if (ProductSectionController && ProductSectionController.prototype) {
        ProductSectionController.prototype.formatMoney = function (amount) {
          return formatMoney(amount);
        };
      }
    } catch (e) {}
  }

  /* ---- 2. wat al getekend is rechtzetten -------------------------------- */

  var SELECTOR = [
    '.product-info__price-wrap',
    '[data-product-price]',
    '[data-product-compare-price]',
    '[data-product-savings-badge]',
    '.vm-sticky-atc__prices',
    '.cart-drawer__item-priceline',
    '.cart-drawer__summary',
    '.cart-page__item-pricing'
  ].join(',');

  function fixTextNodes(root) {
    if (!root || !document.createTreeWalker) return;

    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null, false);
    var node;

    while ((node = walker.nextNode())) {
      var text = node.nodeValue;
      if (!text || text.indexOf('€') === -1) continue;

      var fixed = text.replace(MONEY_AFTER, function (match, sign, amount) {
        return (sign || '') + '€' + amount;
      });

      if (fixed !== text) node.nodeValue = fixed;
    }
  }

  function sweep() {
    var blocks = document.querySelectorAll(SELECTOR);
    for (var i = 0; i < blocks.length; i++) fixTextNodes(blocks[i]);
  }

  /* Meteen (dit script staat ná beide bestanden), en daarna nog twee keer als
     vangnet voor blokken die later pas verschijnen. */
  patch();
  sweep();

  document.addEventListener('DOMContentLoaded', function () {
    patch();
    sweep();
  });

  window.addEventListener('load', sweep);
})();
